import dayjs from 'dayjs';
import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { DateFormat } from '@/modules/core/app/constants/date.constants';

export class DocumentClosingLetterMeta extends BaseEntityModel {
  parentId?: number;
  sentOnDate?: string;

  constructor(model: Partial<DocumentClosingLetterMeta> = {}) {
    super(model);

    this.parentId = model.parentId;
    this.sentOnDate = model.sentOnDate;
  }

  get formattedSentOnDate(): string {
    return dayjs(this.sentOnDate).format(DateFormat.FULL_MONTH_DAY_YEAR);
  }

  get formattedEstateLockedOnDate(): string {
    return dayjs(this.sentOnDate).add(30, 'days').format(DateFormat.FULL_MONTH_DAY_YEAR);
  }
}
